import { type FC, useEffect } from 'react';
import { useEntityConfig } from '../../hooks/useEntityConfig';
import { TEmbedPostMessage } from '../../types';

type TPostMessageListenerProps = {
  onSuccessLogin: () => void;
};

export const PostMessageListener: FC<TPostMessageListenerProps> = ({ onSuccessLogin }) => {
  const config = useEntityConfig();

  useEffect(() => {
    const handleMessage = (event: MessageEvent): void => {
      let allowedOrigin: string | null = null;

      try {
        if (config.VITE_URL_ID_FRONTEND) {
          allowedOrigin = new URL(config.VITE_URL_ID_FRONTEND).origin;
        }
      } catch {
        console.error('Invalid URL:', config.VITE_URL_ID_FRONTEND);

        return;
      }

      if (!allowedOrigin || event.origin !== allowedOrigin) {
        return;
      }

      const { type }: TEmbedPostMessage = event.data;

      if (type === 'onSuccessLogin') {
        onSuccessLogin();
      }
    };

    window.addEventListener('message', handleMessage);

    return () => window.removeEventListener('message', handleMessage);
  }, [config.VITE_URL_ID_FRONTEND, onSuccessLogin]);

  return null;
};
